export default "__VITE_ASSET__DbBkeOPL__"